// verseReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tabVerseListNew: [
    { book: 0, chapter: 0, verses: [], read: false, verseTotal: 0, showLeftArrow: false, showRightArrow: false },
    { book: 0, chapter: 0, verses: [], read: false, verseTotal: 0, showLeftArrow: false, showRightArrow: false },
    { book: 0, chapter: 0, verses: [], read: false, verseTotal: 0, showLeftArrow: false, showRightArrow: false },
    { book: 0, chapter: 0, verses: [], read: false, verseTotal: 0, showLeftArrow: false, showRightArrow: false }
  ],
};

const verseSlice = createSlice({
  name: 'verse',
  initialState,
  reducers: {
    setTabVerseListNew(state, action) {
      state.tabVerseListNew = action.payload;
    },
    reset4Verse() {
      return initialState;
    },
  },
});

export const { setTabVerseListNew, reset4Verse } = verseSlice.actions;
export default verseSlice.reducer;
// const initialState = {
//   tabVerseListNew: [ //tabVerseList
//     {id: 0, book: 0, chapter: 0, verses: [], read: false, verseTotal: 0, showLeftArrow: false, showRightArrow: false}, 
//     {id: 1, book: 0, chapter: 0, verses: [], read: false, verseTotal: 0, showLeftArrow: false, showRightArrow: false}, 
//     {id: 2, book: 0, chapter: 0, verses: [], read: false, verseTotal: 0, showLeftArrow: false, showRightArrow: false}, 
//     {id: 3, book: 0, chapter: 0, verses: [], read: false, verseTotal: 0, showLeftArrow: false, showRightArrow: false}
//   ],
//   // tabVerseList: [ //tabVerseList
//   //   {book: 0, chapter: 0, details: []}, 
//   //   {book: 0, chapter: 0, details: []}, 
//   //   {book: 0, chapter: 0, details: []}, 
//   //   {book: 0, chapter: 0, details: []}
//   // ],
//   // selectedVerses: [
//   //   {book: 0, chapter: 0, selected: []}, 
//   //   {book: 0, chapter: 0, selected: []}, 
//   //   {book: 0, chapter: 0, selected: []}, 
//   //   {book: 0, chapter: 0, selected: []}
//   // ],
//   // hasNoteVerses: [
//   //   {book: 0, chapter: 0, hasNote: []}, 
//   //   {book: 0, chapter: 0, hasNote: []}, 
//   //   {book: 0, chapter: 0, hasNote: []}, 
//   //   {book: 0, chapter: 0, hasNote: []}
//   // ],
//   //loading4Verse: false,
// };

// export default function verseReducer(state = initialState, action) {
//   switch (action.type) {
//     //tabVerseListNew
//     case 'setTabVerseListNew':
//       return {
//         ...state,
//         tabVerseListNew: action.payload,
//       };    
//     // case 'setSelectedVerses':
//     //   return {
//     //     ...state,
//     //     selectedVerses: action.payload,
//     //   };            
//     // case 'setLoading4Verse':
//     //   return {
//     //     ...state,
//     //     loading4Verse: action.payload,
//     //   };
//     case 'reset4Verse':
//       return initialState;        
//     default:
//       return state;
//   }
// }
// //New
// export const setTabVerseListNew = (e) => ({
//   type: 'setTabVerseListNew',
//   payload: e,
// });

// // export const setTabVerseList = (e) => ({
// //   type: 'setTabVerseList',
// //   payload: e,
// // });

// // export const setSelectedVerses = (e) => ({
// //   type: 'setSelectedVerses',
// //   payload: e,
// // });

// // export const setLoading4Verse = (e) => ({
// //   type: 'setLoading4Verse',
// //   payload: e,
// // });

// export const reset4Verse  = (e) => ({
//   type: 'reset4Verse',
//   payload: e,
// });